import { MessageSchema } from ".";

export default {
    action: {
        add: "Add",
        create: "Create",
        validate: "Validate",
        createNew: "Create new",
        update: "Edit",
        delete: "Delete",
        confirm: "Confirm",
        cancel: "Cancel",
        close: "Close",
        save: "Save",
        clear: "Clear",
        send: "Send",
        search: "Search",
        print: "Print",
        import: "Import",
        synchronize: "Synchronize",
        share: "Share",
        duplicate: "Duplicate",
        renew: "Renew",
        ok: "Ok",
        retry: "Retry",
        REDIRECT_CALENDAR: "Create and schedule appointment",
        REDIRECT_FOLDER: "Create and access file",
        correct: 'Correct'
    },
    common: {
        info: "Info",
        title: "Title",
        file: "File",
        url: "Url",
        default: "Default",
        selection: "Selection",
        appointment: {
            status: {
                title: "Status",
                WAITING_ROOM: "Waiting room",
                SCHEDULED: "Scheduled",
                HONOURED: "Honoured",
                NOT_HONOURED: "Not honoured",
                TO_VALIDATE: "To validate",
                CANCELLED: "Cancelled"
            },
            patientWarningMsg: 'The patient could not be retrieved, but you can still edit this appointment.'
        },
        me: "Me",
        yes: "Yes",
        no: "No",
        loading: "Loading ...",
        date: "Date",
        from: "From",
        until: "Until",
        amount: "Amount",
        status: {
            'active': "Active",
            'unactive': "Disabled"
        },
        pageable: {
            showing: "Showing {first} to {last} of {total}"
        },
        frequency: {
            EVERY_WEEK: "Every week",
            EVERY_TWO_WEEKS: "Every 2 weeks",
            EVERY_THREE_WEEKS: "Every 3 weeks"
        },
        honorifics: {
            NONE: "",
            MALE: "Mr.",
            FEMALE: "Ms.",
            NON_BINARY: ""
        },
        gender: {
            MALE: "Male",
            FEMALE: "Female",
            NONE: "Not defined",
            NON_BINARY: "Other"
        },
        patient: 'Patient',
        patients: 'Patients',
        healthPro: 'Healthcare professional',
        healthPros: 'Healthcare professionals',
        user: 'User',
        users: 'Users',
        personRole: {
            HEALTHPRO: "Doctor",
            HEALTHPROASSISTANT: "Assistant",
            HEALTHPROSTUDENT: "Medical student"
        },
        toast: {
            error: "An error occurred",
            warning: "Invalid action",
            success: {
                add: "Successfully created",
                update: "Successfully updated",
                delete: "Successfully deleted",
                cancel: "Successfully cancelled",
                deactivate: "Successfully deactivated",
            }
        },
        patientStatus: {
            WAITING: "Upcoming",
            LEAVE: "Completed",
            OUT: "Patient left"
        },
        newInput: "Add: {inputValue}",
        version: "v{version}",
        calendar: {
            future: "Future",
            now: "Current",
            months: "{count} months",
            weeks: "1 week | {count} weeks",
            days: "1 day | {count} days"
        },
        contactForm: {
            title: {
                phone: "Phone",
                email: "Email",
                address: "Address"
            },
            label: {
                phone: {
                    actionDefault: "Use by default",
                    isDefault: "Used by default"
                },
                address: {
                    actionDefault: "Use by default",
                    isDefault: "Used by default"
                },
                email: {
                    actionDefault: "Use by default",
                    isDefault: "Used by default"
                } 
            }
        }
    },
    error: {
        DEFAULT: "An error occurred",
        EXPRESSION_SAVE_FAILED: "Sign not saved",
        REQUIRED: "Required data",
        REDIRECT: "Redirect is not possible",
        ACTION_FORBIDDEN: "Action not authorized",
        APPOINTMENT_TYPE_NOT_FOUND: "Unknown appointment type",
        APPOINTMENT_TYPE_FORBIDDEN_EDIT: "Appointment type modification not authorized",
        INSTITUTE_WITH_ROLE_NOT_FOUND: "Unknown institute",
        USER_FORBIDDEN: "You do not have permission to perform this action",
        USER_WITHOUT_AVAILABLE_MODULE: "You do not have access to application modules. Please contact an administrator.",
        INSTITUTE_ADDRESS_NOT_FOUND: "No address for this institute",
        INSTITUTE_ADDRESS_FORBIDDEN_EDIT: "Modification forbidden for this address",
        INSTITUTE_ROOM_NOT_FOUND: "Unknown waiting room",
        INSTITUTE_ROOM_FORBIDDEN_EDIT: "Waiting room modification not authorized",
        PERSON_ADDRESS_NOT_FOUND: "Unknown address",
        PERSON_ELEMENT_NOT_ASSOCIATED: "Element is not associated with the person",
        PERSON_EMAIL_NOT_FOUND: "Unknown email address",
        PERSON_PHONE_NOT_FOUND: "Unknown phone number",
        PERSON_WITH_ROLE_NOT_FOUND: "Unknown person",
        USER_AUTHENTICATED_FAILED: "Authentication failed",
        SETTINGS_WEEK_MODEL_NOT_FOUND: "Unknown standard week",
        SETTINGS_WEEK_MODEL_NAME_EXIST: "A standard week with this name already exists",
        SETTINGS_DAY_MODEL_NOT_FOUND: "Unknown standard day",
        SETTINGS_DAY_MODEL_NAME_EXIST: "A standard day with this name already exists",
        APPOINTMENT_NOT_FOUND: "Unknown appointment",
        TIMESLOT_UNAVAILABLE: "Doctor unavailable at this date",
        EMPTY_LOCATION: "Waiting room is required",
        HEALTH_GROUP_MEMBER_NOT_FOUND: "Unknown institute",
        SPECIAL_DAY_PERIOD_ALREADY_EXIST: "A special day already exists for this date",
        SPECIAL_DAY_NOT_FOUND: "Unknown special day",
        SPECIAL_DAY_PERIOD_BEFORE_ERROR: "End date cannot be before start date",
        APPOINTMENT_DATE_IN_PAST: "You cannot edit an appointment that has already taken place",
        APPOINTMENT_ALREADY_FINISH: "Appointment has already been declared finished",
        APPOINTMENT_CANCELED: "The appointment has been canceled, you cannot reschedule it",
        APPOINTMENT_MOVE_DOCTOR_FORBIDDEN: "You cannot reschedule this appointment with another doctor",
        APPOINTMENT_MOVE_TYPE_FORBIDDEN: "You cannot move this appointment to a different appointment type",
        MOVE_APPOINTMENT_IN_PROGRESS: "An appointment is being rescheduled",
        APPOINTMENT_MOVE_PATIENT_FORBIDDEN: "You cannot reschedule this appointment for another patient",
        APPOINTMENT_DURATION_TOO_LONG: "An appointment cannot span several days",
        DELETE_FORBIDDEN_NOT_CURRENT_ENTRY: "Deletion not possible (This entry is not in a current consultation)",
        DELETE_FORBIDDEN_LAST_ITEM: "Deletion not possible (Only one entry present in consultation)",
        DELETE_FORBIDDEN_NOT_SAP_CURRENT_ENTRY: "Deletion not possible (This entry is not in a current consultation)",
        DELETE_FORBIDDEN_NOT_EMPTY_CONCLUSION: "Consultation is not empty",
        DELETE_FORBIDDEN_CONCLUSION_WITH_ORDER_1: "The last group of the consultation cannot be deleted",
        DELETE_FORBIDDEN_EXPRESSION_TITLE_GROUP: "Deletion not possible (this entry is used in a group)",
        VIDEO_NOT_FOUND: "The requested video does not exist",
        VIDEO_UNVAILABLE: "No video available",
        DIRECTORY_NOT_FOUND: "The requested directory does not exist",
        TASK_BOX_MODULE_NOT_FOUND: "Task module does not exist",
        APP_USE_NOT_FOUND: "User does not exist",
        USER_NOT_IN_INSTITUT: "User does not belong to an institute",
        USER_SSN_EXIST: "LuxTrust identifier already assigned",
        DOCTOR_HEALTH_GROUP_MEMBER_NOT_FOUND: "Unknown doctor",
        PERSON_NOT_SPECIFIED: "Person not specified",
        INSTITUTE_NOT_SPECIFIED: "Institute not specified",
        INSTITUTE_WITHOUT_HEALTH_PRO_GROUP_ROLE: "Institute without defined role",
        CANNOT_DELETE_LAST_INSTITUTE_ADDRESS: "The last address of an institute cannot be deleted",
        PERSON_ALREADY_LINKED_WITH_INSTITUTE: "Person already linked to this institute",
        CREATE_PERSON_ERROR: "An error occurred while creating the person",
        MANDATORY_DATA_MISSING: "Required data missing",
        PERSON_GENDER_TYPE_ERROR: "Unknown gender",
        PERSON_CNS_NUMBER_ERROR: "Invalid matricule format",
        PERSON_CNS_BIRTHDATE_ERROR: "This security number does not correspond to a valid date of birth",
        IS_NOT_A_DOCTOR: "User is not a doctor",
        HAS_NO_PLANNING: "No shared calendar",
        APPOINTMENT_MANDATORY: "Name and duration are required",
        APPOINTMENT_TYPE_NAME_EXIST: "An appointment type with this name already exists",
        APPOINTMENT_TYPE_NOTE_LENGTH: "Note cannot exceed 255 characters",
        NO_PATIENT: "Selected patient does not exist",
        FINANCIAL_GROUP_NOT_FOUND: "Unknown financial group",
        FINANCIAL_CHANNEL_NOT_FOUND: "Unknown financial channel",
        FINANCIAL_CHANNEL_AND_GROUP_ERROR: "Financial channel does not belong to financial group",
        FINANCIAL_BANK_ACCOUNT_NOT_FOUND: "Unknown bank details",
        FINANCIAL_BANK_ACCOUNT_FORBIDDEN_EDIT: "Bank details cannot be modified",
        SETTINGS_CHANNEL_PERMISSION_NOT_FOUND: "Unknown financial channel permission",
        CNS_ALREADY_EXIST: "CNS code already exists for another person",
        RELATION_ID_AND_PATIENT_ID_ARE_NULL: "Unknown patient",
        CNS_AFFILIATION_NUMBER_SUFFIX_LENGTH: "ID suffix must be 5 characters",
        CNS_HEALTH_INSURANCE_NOT_FOUND: "Unknown matricule",
        GET_PERSON_ERROR: "Error retrieving person",
        UPDATE_PERSON_ERROR: "Error updating person data",
        TASKBOX_ALREADY_ASSIGN: "Task is already assigned to 2 people",
        TASKBOX_RESULT_ALREADY_EXIST: "'Results' task already exists",
        PATIENT_DOCUMENT_GROUP_NOT_FOUND: "Document group does not exist",
        PERSON_AND_PATIENT_ALREADY_ASSOCIATED: "Person is already associated with patient",
        ADD_PERSON_TO_PATIENT_ERROR: "Selected person cannot be added to this patient",
        INSTITUTE_PID_ACTIVE_BUT_NOT_HEALTH_GROUP_PRO: "Institute must have Health Pro Group role to activate PID",
        NO_DATA: "The submission file could not be generated",
        HOSPI_DURATION_TOO_LONG: "Hospital stay duration exceeds the limit of {days} days.",
        INVOICE_GENERATE_ERROR: "An error occurred while generating the fee statement, please try again",
        FINANCIAL_GROUP_MISSING_IBAN: "The fee note could not be generated because the financial group’s IBAN is missing",
        SETTINGS_DAYS_BY_WEEK_MODEL_NOT_FOUND: "Unknown day configuration",
        CNS_AFFILIATION_NUMBER_INVALID: "Invalid matricule",
        RELATION_ID_IS_NULL: "Missing relationship ID",
        CNS_NUMBER_IS_EMPTY: "Missing matricule.",
        INSTITUTE_ID_IS_NULL: "Missing institute ID",
        FEE_WRONG_FORMAT: "Amount must be a decimal number",
        NO_PDFS_FOUND: "No PDFs found",
        PDF_LOADING_ERROR: "Error loading PDF",
        TIMESLOT_PERIOD_ALREADY_EXIST: "A week is already applied to this period",
        SETTINGS_WEEK_MODEL_USED: "The week is used in a period",
        INSTITUTE_EMAIL_IS_USED: "The email is used by one or more medical staff",
        INSTITUTE_PHONE_IS_USED: "The phone number is used by one or more medical staff",
        INSTITUTE_ADDRESS_IS_USED: "The address is used by one or more medical staff",
        FINANCIAL_GROUP_CODE_TOO_LONG: "The financial group code must be three characters long",
        FINANCIAL_GROUP_MISA_TOO_LONG: "The Misa number of the financial group must be eight characters long",
        FINANCIAL_GROUP_ONLY_ONE_PID: "This financial group already has a PID-channel (only one allowed)",
        INSTITUTE_HEADER_NOT_FOUND: "This header could not be found",
        INSTITUTE_HEADER_CANNOT_DELETE_LAST: "Cannot delete the last header of the institute",
        INSTITUTE_HEADER_IS_USED: "This header is used by one or more people",
        PATIENT_DOCUMENT_NOT_CURRENT_ENTRY: "This document does not belong to the current entry",
        HEALTH_PRO_HAS_APPOINTMENT: "An appointment has been scheduled for this healthcare professional",
        ENTRY_RELATION_NOT_FOUND: "Unknown entry",
        NOT_ENTRY_FOR_THIS_PATIENT: "This entry is not associated with the patient",
        NEW_DOSETIMING: "A new dosage has been defined for a medication in this entry. Do you want to continue deleting it ?",
        ECOSYSTEM_USED_ANOTHER_ENTRY: "An ecosystem is in use in another session. Do you want to continue with the deletion ?",
        HISTORY_USED_ANOTHER_ENTRY: "A history entry is being used in another consultation. Do you want to continue deleting it ?",
        MONITORING_USED_ANOTHER_ENTRY: "A monitoring session is in use in another consultation. Do you want to continue deleting ?",
        BASIC_USED_ANOTHER_ENTRY: "A concept is being used in another consultation. Do you want to continue deleting it ?"
    },
    warn: {
        APPOINTMENT_EXIST: "Warning, appointments have been scheduled for this date.",
        TOO_LONG: "Warning, appointment duration exceeds available time slot",
        NO_TIME_SLOT_FOR_APPT_TYPE_MSG: "This appointment type is not configured for this time",
        ONE_DOCTOR_SELECTED: "At least one doctor must be selected",
        INVALID_DATE_TIME: "Invalid date format"
    },
    enum: {
        languages: {
            FR: 'French',
            EN: 'English',
            DE: 'German',
            ES: 'Spanish',
            IT: 'Italian',
            PT: 'Portuguese',
            NL: 'Dutch',
            LU: 'Luxembourgish'
        },
        weekday: {
            MONDAY: "Monday",
            TUESDAY: "Tuesday",
            WEDNESDAY: "Wednesday",
            THURSDAY: "Thursday",
            FRIDAY: "Friday",
            SATURDAY: "Saturday",
            SUNDAY: "Sunday"
        }
    },
    menu: {
        settings: 'Settings',
        admin: 'Admin',
        logout: 'Logout',
        help: 'Help',
        tutorial: {
            videoNotDisplay: 'Your browser does not support video playback',
            selectVideo: 'Select a video'
        },
        idea: 'Suggestion box',
        news: 'eSklepios News',
        version: "Version {version}",
        contactSupport: "Contact technical support",
        fullscreen: 'Fullscreen',
        institute: 'Institute'
    },
    academic: {
        menu: {
            mycme: "my cme",
            cmePulication: "alformec",
            cmeValidation: "accreditation"
        }
    },
    office: {
        menu: {
            incomes: "income",
            expenses: "expenses",
            stock: "stock",
            orders: "orders"
        }
    },
    settings: {
        notification: {
            reminderTitle: "Appointment reminder notifications",
            isTodayReminderEnabled: "On the same day",
            isOneDayBeforeReminderEnabled: "The day before",
            isThreeDaysBeforeReminderEnabled: "Three days before",
            isOneWeekReminderEnabled: "One week before"
        },
        titleLabels: {
            title1: 'Title 1',
            title2: 'Title 2',
            title3: 'Title 3',
            title4: 'Title 4',
            title5: 'Title 5',
            title6: 'Title 6'
        },
        permissions: {
            institutes: "Institutes"
        },
        menu: {
            duration: "{numberMin} min",
            organization: "Institute",
            mySettings: "My preferences",
            appointmentTypes: "Appointment types",
            waitingRoom: "Waiting rooms",
        },
        title: {
            language: "Language",
            appointment: "Appointments",
            appointmentType: "List of appointment types"
        },
        tab: {
            main: "General",
            appointmentTye: "Appointment types",
            specialDays: "Special days",
            planning: "Planning",
            dayModel: "Standard days"
        },
        calendar: {
            noHealthPro: "You have no configurable calendar"
        },
        label: {
            main: {
                subtitle: {
                    calendar: "Calendar settings"
                },
                duration: {
                    label: "Appointment slot duration (in min)",
                    success: {
                        update: "Slot duration updated successfully"
                    }
                },
                beforeDay: {
                    label: "Maximum number of days in advance a patient can book an appointment",
                    success: {
                        update: "Number of days updated successfully"
                    }
                },
                cancelHour: {
                    label: "Minimum number of hours before the appointment a patient can cancel it",
                    success: {
                        update: "Number of hours updated successfully"
                    }
                },
                generalMessage: {
                    label: "Message for patients",
                    success: {
                        update: "Message successfully updated"
                    }
                },
                permissions: {
                    title: "Access to my calendar",
                    loading: "Loading ...",
                    empty: "No permissions defined",
                    access: "Access",
                    admin: "Administration",
                    message: {
                        success: {
                            update: "Permission successfully updated"
                        }
                    }
                },
                weekDay: "Days to display in calendar",
                message: {
                    success: {
                        update: "Display days successfully updated"
                    }
                }
            },
            select: {
                institutes: "Institute",
                healthpros: "Healthcare professional"
            },
            specialDays: {
                modal: {
                    header: "Edit special day hours",
                    date: "Date",
                    range: "Select period",
                    dayModel: "Standard day",
                    period: "Period",
                    add: {
                        title: "Create special day",
                    },
                    delete: {
                        title: "Delete special day",
                        message: "You are about to delete a special day",
                    }
                },
                toast: {
                    created: "Special day successfully created",
                    updated: "Special day successfully updated",
                    deleted: "Special day successfully deleted",
                },
                labelQuickParam: "Special day of {specialDayDate}"
            },
            weekModel: {
                message: {
                    success: {
                        update: "Standard week successfully updated"
                    }
                },
                nameOfNew: "New standard week {counter}",
                action: {
                    add: {
                        button: "Add a week type"
                    }
                }
            },
            dayModel: {
                unavailable: "Default unavailability template. No configuration required",
                selectOrCreate: "Select or create a standard day",
                form: {
                    name: "Name",
                    timeslot: {
                        start: "Start",
                        end: "End",
                        delete: "Delete"
                    },
                    header: {
                        add: "Add standard day",
                        name: "Edit standard day name",
                        timeslot: "Edit standard day hours",
                        delete: "Delete standard day"
                    },
                    message: {
                        delete: "You are about to delete a standard day",
                        success: {
                            add: "Day successfully added",
                            update: "Day successfully modified",
                            timeslot: "Standard day hours successfully modified",
                            delete: "Standard day successfully deleted"
                        }
                    }
                }
            },
            planning: {
                action: {
                    openWeekModel: "Manage standard weeks",
                    addTimeslot: "Add a period",
                    deleteSelected: "Delete selected periods"
                },
                weekModel: {
                    header: "Standard weeks management",
                    weekStandard: "Standard week"
                },
                noData: "No period configured",
                column: {
                    slot: "Period",
                    weekModel: "Applied standard week"
                },
                tooltip: "At least one special day is included in this period. Special days override the selected week configuration.",
                modale: {
                    delete: {
                        header: "Delete period",
                        message: "You are about to delete a period"
                    },
                    deleteSelected: {
                        header: "Delete periods",
                        message: "You are about to delete multiple periods"
                    },
                    addTimeslot: {
                        header: "Add a period",
                        startDate: "Start date",
                        endDate: "End date",
                        frequency: "Frequency",
                        weekModel: "Standard week",
                        startDateRequired: "Please enter the start date",
                        endDateRequired: "Please enter the end date",
                        frequencyRequired: "Please enter the frequency",
                        weekModelRequired: "Please enter the standard week",
                        warning: "If the new period overlaps an already configured period, the existing configuration will be replaced by the new one."
                    }
                },
                message: {
                    success: {
                        delete: "Period successfully deleted",
                        update: "Period successfully modified",
                        add: "Period successfully added"
                    }
                }
            },
            appointmentType: {
                fieldColor: "Color",
                name: "Name",
                order: "Order",
                duration: "Duration",
                note: "Message for patients",
                offline: "Portal appointment booking",
                action: "Action",
                online: "Open",
                patient: "Reserved for trusted patients",
                offlineStatus: "Unavailable",
                durationUnit: "{count} min x",
                explanationDuration: "Duration is the product of the value entered during creation and the default duration set in the \"General\" tab.",
                delete: {
                    header: "Delete appointment type",
                    message: "You are about to delete an appointment type"
                },
                add: {
                    header: "Add appointment type"
                },
                update: {
                    name: "Edit appointment type name"
                },
                message: {
                    success: {
                        update: "Type successfully updated",
                        add: "Type successfully added",
                        delete: "Type successfully deleted"
                    }
                }
            },
            waitingRoom: {
                name: "Name",
                nameRequired: "Please enter a name",
                maxLivePlaces: 'Maximum capacity',
                address: "Address",
                badge: "Badge",
                noBadge: "No badge",
                noAddress: "No address",
                byDefault: "Default",
                street: "Street",
                action: "Action",
                add: {
                    header: "Add waiting room"
                },
                edit: {
                    header: "Edit waiting room"
                },
                delete: {
                    header: "Delete waiting room",
                    message: "You are about to delete a waiting room"
                },
                message: {
                    success: {
                        update: "Waiting room successfully updated",
                        add: "Waiting room successfully added",
                        delete: "Waiting room successfully deleted"
                    }
                }
            },
            instituteInformation: {
                name: "Name",
                action: "Action",
            },
            accounting: {
                financialGroup: {
                    title: "Groups",
                    unactive: "Financial group is disabled",
                    optionDisabled: "{name} (disabled)",
                    table: {
                        code: "Code",
                        title: "Title",
                        active: "Active",
                        empty: "No financial group"
                    },
                    message: {
                        success: {
                            update: "Financial group successfully updated",
                            add: "Financial group successfully added"
                        }
                    },
                    form: {
                        header: {
                            add: "Add financial group",
                            update: "Edit financial group"
                        },
                        code: "Code",
                        personalInfo: "Additional info",
                        title: "Title",
                        iban: "IBAN",
                        bic: "BIC code"
                    },
                    financialChannel: {
                        empty: "Select or create a financial group",
                        add: {
                            action: "Add channel",
                            header: "Add channel",
                            message: {
                                success: "Channel successfully added"
                            }
                        },
                        permissions: {
                            title: "Permissions for this group",
                            payment: "Payments",
                            edition: "Edition",
                            creation: "Creation"
                        },
                        type: {
                            None: "None",
                            BankAccount: "Bank account",
                            BankCard: "Bank card",
                            Cash: "Cash",
                            LuPid: "Pid",
                            DigitalPayment: "Digital payment",
                            LuTp: "Tp",
                            LuTpSocial: "Social Tp",
                            Cancelled: "Cancelled"
                        },
                        data: {
                            title: "Title",
                            type: "Type",
                            active: "Active",
                            bank: {
                                fullName: "Name",
                                shortName: "Short name",
                                bic: "BIC code",
                                iban: "IBAN"
                            }
                        },
                        update: {
                            title: "Edit channel title",
                            message: {
                                success: "Channel successfully modified"
                            }
                        },
                        error: {
                            missingIban: "A bank account cannot be active and not have an IBAN"
                        }
                    }
                }
            },
            patient: {
                managementDelegate: {
                    title: "Create patient entry on my behalf",
                    loading: "Loading ...",
                    empty: "No delegation defined",
                    update: {
                        message: {
                            success: "Delegation successfully modified"
                        }
                    }
                }
            },
            account: {
                institute: {
                    preference: {
                        header: "Contact preference for {instituteName}",
                        headerLines: "Header",
                        address: "Address",
                        phone: "Phone",
                        email: "Email",
                        warning: "This data will be visible on documents generated by the application (prescriptions, fee statements) and the appointment booking portal.",
                        message: {
                            success: "Preferences updated successfully"
                        }
                    }
                }
            },
            task: {
                taskbox: {
                    title: "Tasks",
                    add: {
                        header: "Add task",
                        message: {
                            success: "Task successfully added"
                        }
                    },
                    update: {
                        header: "Edit task",
                        message: {
                            success: "Task successfully modified"
                        }
                    },
                    data: {
                        title: "Title",
                        module: "Module type"
                    },
                    moduleType: {
                        NONE: "None",
                        PATIENT: "Patient",
                        ACCOUNTING: "Accounting",
                        STOCK: "Stock",
                        STAFF: "Staff",
                        LEARNING: "Learning",
                        TEACHING: "Teaching",
                        RESEARCH: "Research"
                    },
                    channelType: {
                        NONE: "None",
                        RESULTS: "Result",
                        TWOPERSON: "Two people",
                    }
                }
            }
        },
        error: {
            numberMaxChar: "Field must be less than 255 characters",
        },
        params: {
            title: "Settings",
            tabs: {
                billing: "Billing"
            },
            preferences: {
                title: "Preferences",
                subTitle: "Preferences",
                language: {
                    title: "Language",
                    menus: "Menus",
                    snomedct: "Text recognition",
                },
                suggestions: {
                    title: "Suggestions",
                    humanBody: "Body diagram",
                    neuro: "Neuro",
                    ent: "ENT",
                    thorax: "Thorax",
                    abdomen: "Abdomen",
                    lymph: "Lymph",
                },
                clinical: {
                    title: "Clinical",
                    reducedByDefault: "Consultations reduced by default",
                    dashboardOphtalmo: "Ophthalmology dashboard",
                },
            },
            account: {
                details: {
                    title: 'Title',
                    address: "Addresses",
                    contact: "Contacts",
                    email: "Address",
                    mobile: "Mobile",
                    phone: 'Number',
                    note: "Note"
                },
                prescription: {
                    header: "Header",
                    labelTitleLine1: "Header line 1 on prescription",
                    labelTitleLine2: "Header line 2 on prescription",
                    labelCustomLine1: "Header line 1",
                    labelCustomLine2: "Header line 2",
                    instituteName: "Institute",
                    instituteFullName: "Full name",
                    instituteShortName: "Short name",
                    title: "Prescription headers"
                },
                institutes: {
                    roles: {
                        admin: "Administrator",
                        customLearningSpeaker: "Continuing medical education creator",
                        customPatient: "Patient",
                        healthPro: "Doctor",
                        healthProAssistant: "Secretary"
                    },
                    title: "Institutes",
                    portailPatient: {
                        title: "Patient portal information",
                        parking: {
                            title: "Parking",
                            nameRequired: "Please enter a name",
                            add: "Add parking",
                            update: "Edit parking",
                            delete: "Delete parking",
                            message: "You are about to delete a parking",
                        },
                        transportStop: {
                            title: "Public transport",
                            nameRequired: "Please enter a name",
                            add: "Add stop",
                            update: "Edit stop",
                            delete: "Delete stop",
                            message: "You are about to delete a stop",
                        },
                        slug: {
                            title: "Institute URL",
                            format: 'Letters without accents or numbers, separated by hyphens',
                            formatError: "The URL does not comply with the allowed format",
                            mandatory: "The URL is required",
                            alreadyUsed: "This URL already exists, please choose a different one",
                            success: "URL updated successfully",
                            error: "Error updating the URL"
                        },
                        generalMessage: {
                            title: "Information message",
                        }
                    }
                },
                title: "Account",
                toast: {
                    add: {
                        address: "Address successfully added",
                        email: "Email address successfully added",
                        phone: "Phone number successfully added",
                        header: "Header added successfully",
                    },
                    delete: {
                        address: "Address successfully deleted",
                        email: "Email address successfully deleted",
                        phone: "Phone number successfully deleted",
                        parking: "Parking successfully deleted",
                        stop: "Stop successfully deleted",
                        header: "Header deleted successfully",
                    },
                    update: {
                        address: "Address successfully modified",
                        email: "Email address successfully modified",
                        phone: "Phone number successfully modified",
                        information: "Information successfully modified",
                        header: "Header updated successfully",
                    }
                },
                subTitle: "Personal data",
                portailPatient: {
                    title: "Patient portal information",
                    fees: "Fees",
                    meanOfPayement: "Payment methods",
                    presentation: "Presentation",
                    diploma: "Degrees",
                    teleconsultation: "Teleconsultation available",
                    openToNewPatient: "Open to new patients",
                    showAgenda: "Show schedule",
                    showContact: "Display on the portal",
                    schedule: "Hours",
                    complementaryInformation: "Additional information",
                    generalMessage: "Information message",
                    slug: {
                        title: "Portal URL",
                        format: 'Letters without accents or numbers, separated by hyphens',
                        formatError: "The URL does not comply with the allowed format",
                        mandatory: "The URL is required",
                        alreadyUsed: "This URL already exists, please choose a different one",
                        success: "URL updated successfully",
                        error: "Error updating the URL",
                        noInstituteSlugs: "No institutes available on the portal"
                    },
                }
            },
            institute: {
                title: "Institute",
                subTitle: "Institute data"
            },
            patient: {
                title: "Patient files",
                subTitle: "Patient data"
            },
            docPatient: {
                title: "Patient Documents",
                subTitle: "Patient documents"
            },
            calendar: {
                title: "Calendar",
                subTitle: "Calendar"
            },
            task: {
                title: "Tasks",
                subTitle: "Tasks"
            },
            waitingRoom: {
                title: "Waiting rooms"
            },
            tasks: {
                title: "Tasks",
                subTitle: "Tasks",
                patientnote: "File note",
                clinic: "Clinical note",
                admin: "Administrative note"
            },
            billing: {
                title: "Billing",
                subTitle: "Billing"
            },
            permission: {
                title: "Permissions",
                subTitle: "Permissions",
                update: "Permission modified"
            },
            notification: {
                title: "Notifications",
                subTitle: "Notifications"
            }
        },
        permission: {
            viewUsers: "View users",
            editUsers: "Edit users",
            writePrescriptions: "Write prescriptions",
            viewAppointments: "View appointments",
            empty: "No permission",
            roles: {
                admin: {
                    label: "Institute administration",
                    ADMIN_INSTITUTE: "Institute administration",
                },
                prescription: {
                    label: "Prescription",
                    WRITE_PRESCRIPTION: "Create/edit prescription",
                    READ_PRESCRIPTION: "Read prescription",
                    SIGN_PRESCRIPTION: "Sign prescription"
                },
                task: {
                    label: "Tasks / Missions",
                    ACCESS_TASK: "Access task module"
                },
                patient: {
                    label: "Patient",
                    ADD_PATIENT_DOCUMENT: "Create administrative document",
                    MODIFY_PATIENT_DATA: "Modify patient clinical file",
                    READ_PATIENT_DATA: "View clinical files of patients linked to institute",
                    DELETE_PATIENT_DOCUMENT: "Delete administrative document",
                    EDIT_PATIENT_ADMIN_DATA: "Edit patient administrative data"
                },
                planning: {
                    label: "Calendar",
                    CREATE_PLANNING: "Create schedule",
                    ACCESS_PLANNING: "Access calendar module",
                    MODIFY_PLANNING: "Edit schedule",
                    OWNER_PLANNING: "Personal calendar"
                },
                accounting: {
                    label: "Accounting management",
                    ACCESS_ACCOUNTING: "Access accounting module"
                }
            },
            datatableTitle: "List of healthcare professionals",
            title: "Permissions for {name}"
        }
    },
    layout: {
        agenda: "Calendar",
        task: "Tasks",
        patient: "Patient",
        waitingroom: "Waiting room",
        finance: "Accounting",
        forum: "Messaging",
        settings: "Settings",
        material: "Equipment",
        fastPatientCreation: 'New Patient',
        staff: "Staff"
    },
    admin: {
        subMenu: {
            title: "Administration",
            institute: "Institutes",
            medicalPerson: "Healthcare professionals",
            permissions: "Permissions",
            financialGroups: "Financial groups",
            notifications: "Notifications"
        },
        financialGroup: {
            datatableTitle: "List of common financial groups",
            search: "Search",
            table: {
                title: "Name",
                code: "Code",
                active: "Active",
                empty: "No financial group",
                misaNumber: "Misa number",
                personalInfo: "Additional info",
                medicalPerson: "Healthcare professionals"
            },
            form: {
                add: {
                    header: "Add common financial group",
                    message: {
                        success: "Common financial group successfully added"
                    }
                },
                update: {
                    header: "Edit common financial group",
                    message: {
                        success: "Common financial group successfully modified"
                    }
                },
                code: "Code",
                title: "Name",
                misaNumber: "Misa number",
                personalInfo: "Additional info",
                active: "Active"
            },
            person: {
                title: "Healthcare professionals of group {title}",
                search: "Search",
                table: {
                    empty: "No healthcare professional",
                    name: "Full name",
                    role: "Role",
                    active: "Active",
                    isOwner: "Group administrator",
                    delete: "Delete"
                },
                form: {
                    institute: "Institute",
                    person: "Healthcare professional",
                    isOwner: "Group administrator",
                    ownerWarning: "Only one administrator possible. This action will remove existing administration rights."
                },
                add: {
                    message: {
                        success: "Healthcare professional successfully added"
                    }
                },
                update: {
                    header: {
                        confirm: "Administrator modification"
                    },
                    message: {
                        success: "Healthcare professional successfully modified"
                    }
                },
                delete: {
                    modale: {
                        header: "Delete access for healthcare professional",
                        message: "You are about to delete financial group access for a healthcare professional",
                        messageOwner: "You are about to delete financial group access for the administrator"
                    },
                    message: {
                        success: "Healthcare professional access successfully deleted"
                    }
                }
            }
        },
        institute: {
            search: "Search",
            table: {
                name: "Name",
                instituteRole: "Role",
                active: "Active",
                empty: "No institute",
                admin: "Administrator",
                update: "Edit"
            },
            label: {
                add: {
                    header: "Add institute",
                    message: {
                        success: "Institute successfully added"
                    }
                },
                update: {
                    header: "Edit institute",
                    message: {
                        success: "Institute successfully modified"
                    }
                }
            },
            form: {
                data: "Information",
                name: "Name",
                shortName: "Short name",
                role: "Role",
                address: "Address",
                street: "Number and street",
                locality: "City",
                postalCode: "Postal code",
                country: "Country",
                userAdmin: "Administrator",
                options: "Options",
                pidActivation: "PID",
                fastPatientCreationActive: 'Fast patient creation',
                ophthalmoDashboard: 'Ophthalmology dashboard',
                externalId: "External ID",
            },
            person: {
                title: "Administrators of institute {name}",
                search: "Search",
                table: {
                    empty: "No administrator",
                    firstname: "First name",
                    lastname: "Last name",
                    role: "Role"
                },
                add: {
                    message: {
                        success: "Administrator successfully added"
                    }
                },
                header: {
                    generalInfo: "General information",
                    options: "Options"
                },
                form: {
                    firstname: "First name",
                    lastname: "Last name",
                    gender: "Gender",
                    birthdate: "Date of birth",
                    title: "Title",
                    role: "Type",
                    misaNumber: "Doctor code",
                    nlpPref: "Snomed CT language",
                    ssnLt: "Luxtrust identifier",
                    favoritePhone: "Phone",
                    favoriteEmail: "Email",
                    favoriteLanguage: "Spoken languages",
                    portalPatientModule: "Patient portal",
                    iban: "IBAN",
                    bic: "BIC"
                }
            }
        },
        medicalPerson: {
            table: {
                name: "Professional",
                active: "Active",
                institut: "Institutes",
                role: "Role",
                empty: "No professional",
                update: "Edit"
            },
            institute: {
                title: "Institutes of {name}",
                search: "Search",
                table: {
                    empty: "No institute",
                    name: "Institute name",
                    role: "Role",
                    active: "Status",
                    isAdmin: "Administrator",
                    edit: "Edit",
                    delete: "Delete"
                },
                form: {
                    institute: "Institute",
                    adminPermission: "Administrator"
                },
                add: {
                    message: {
                        success: "Institute successfully added"
                    }
                },
                edit: {
                    message: {
                        success: "Institute successfully modified"
                    }
                },
                delete: {
                    modale: {
                        header: "Delete person",
                        message: "You are about to delete a person linked to the institute"
                    },
                    message: {
                        success: "Healthcare professional successfully deleted"
                    }
                }
            },
            form: {
                header: {
                    add: "Add healthcare professional",
                    update: "Edit healthcare professional"
                },
                message: {
                    success: {
                        add: "Healthcare professional successfully added",
                        update: "Healthcare professional successfully modified"
                    }
                }
            }
        },
        notifications: {
            message: {
                success: {
                    add: "Notification template successfully added",
                    update: "Notification template successfully modified"
                }
            },
        }
    },
    calendar: {
        header: {
            weekDays: "From {first} to {last} ",
            todayButton: "Today",
            pastButton: "Previous",
            nextButton: "Next",
            withoutAppointment: "Walk-in",
            tab: {
                day: "Day",
                week: "Week"
            },
            appointment: "Appointment for :",
            moveAppointment: "Rescheduling of the appointment on {date} from:"
        },
        menu: {
            calendar: "Calendar"
        },
        alt: {
            patient: "Patient"
        },
        label: {
            notAccess: "You do not have access to any calendar. To get a calendar, please contact your institute's administrator.",
            forbidden: "{name} does'nt have access to the calendar module",
            update: {
                header: "Edit appointment"
            },
            add: {
                patientWithoutAppointmentHeader: "New walk-in patient",
                header: "New appointment",
                form: {
                    date: "Date",
                    time: "Time",
                    duration: "Duration (in minutes)",
                    appointmentType: "Appointment type",
                    patient: "Patient",
                    portalPatient: "Appointment booked by",
                    healthPro: "Healthcare professionals",
                    comment: "Comment",
                    departure: "Departure time",
                    arrival: "Arrival in waiting room",
                    created: "Created on ",
                    createdAt: "{date} at {time}",
                    createdAtBy: "{date} at {time} by {author}",
                    addPerson: "New patient",
                    lastname: "Last name",
                    firstname: "First name",
                    favoritePhone: "Phone",
                    mobile: "Mobile",
                    mail: "Email",
                    isPatientWithoutAppointment: "Walk-in patient",
                    portalError: 'An error occurred whilst loading the patient.'
                }
            },
            delete: {
                action: "Cancel appointment"
            },
            move: {
                action: "Reschedule appointment",
                disabled: "An appointment has already been selected to be resheduled"
            },
            message: {
                success: {
                    add: "Appointment successfully added",
                    update: "Appointment successfully modified"
                },
                error: {
                    commentLength: "Field must be less than 256 characters"
                }
            },
            settings: {
                header: "Special day of {date}"
            },
            existAppointment: {
                header: "An appointment is already scheduled",
                message: {
                    create: "An appointment has already been scheduled for this slot. Do you wish to continue with the creation?",
                    update: "An appointment has already been scheduled for this slot. Do you wish to continue with the modification?"
                }
            }
        },
        appointment: {
            action: {
                finish: "Confirm departure",
                patientStatus: "Consultation",
                start: "Confirm arrival",
                restart: "Confirm return",
            },
            delete: {
                modale: {
                    header: "Cancel appointment",
                    message: "You are about to cancel an appointment"
                },
                message: {
                    success: "Appointment successfully cancelled"
                }
            }
        },
        waiting: {
            title: "Waiting rooms",
            room: {
                default: "Unknown",
                location: "Waiting room"
            },
        },
        history: {
            title: "History",
        },
        withoutAppointment: {
            title: "Without appointment",
        }
    },
    thirdPerson: {
        create: {
            title: {
                private: "Create third party for {name}",
                pro: "Create healthcare professional for {name}",
            },
            form: {
                firstname: "First name",
                lastname: "Last name",
                address: "Address",
                street: "Number and street",
                postalCode: "Postal code",
                locality: "City",
                country: "Country",
                favoritePhone: "Phone",
                mobile: "Mobile",
            },
            message: {
                success: {
                    add: "Person successfully added"
                },
            }
        },
    },
    healthPro: {
        select: "Select a healthcare professional",
        search: {
            placeholder: "Name ...",
            noResult: "No results",
        },
    },
    patient: {
        common: {
            bio: "Bio",
            biology: "Biology",
            imaging: "Imaging",
            medication: "Medications",
            report: "Report",
            reports: "Reports",
            certificate: "Certificate",
            certificates: "Certificates",
        },
        addMedication: {
            placeholder: "Name or INN ...",
            commercialNames: "Commercial names",
            singleSubstances: "Substances",
            multipleSubstances: "Multiple substances",
        },
        addMonitored: {
            childFollowUp: "Child follow-up",
            adultFollowUp: "Adult follow-up",
            pregnancyFollowUp: "Pregnancy follow-up",
            travelFollowUp: "Travel follow-up",
            favorites: "Favorites",
        },
        addHistory: {
            stroke: "Stroke",
            dementia: "Dementia",
            parkinson: "Parkinson's",
            epilepsy: "Epilepsy",
            migraine: "Migraine",
            adhd: "ADHD",
            depressiveDisorder: "Depressive disorder",
            anxietyDisorder: "Anxiety disorder",
            bipolarDisorder: "Bipolar disorder",
            addictionTo: "Addiction to",
            anorexia: "Anorexia",
            bulimia: "Bulimia",
            autisticDisorder: "Autistic disorder",
            schizophrenia: "Schizophrenia",
            refractionDisorders: "Refractive errors",
            refractionDisordersRightEye: "Refractive errors right eye",
            refractionDisordersLeftEye: "Refractive errors left eye",
            cataract: "Cataract",
            cataractRightEye: "Cataract right eye",
            cataractLeftEye: "Cataract left eye",
            glaucoma: "Glaucoma",
            glaucomaRightEye: "Glaucoma right eye",
            glaucomaLeftEye: "Glaucoma left eye",
            hearingLoss: "Hearing loss",
            hearingLossRightEar: "Hearing loss right ear",
            hearingLossLeftEar: "Hearing loss left ear",
            edentulism: "Edentulism",
            adenoidectomy: "Adenoidectomy",
            tonsillectomy: "Tonsillectomy",
            copd: "COPD",
            asthma: "Asthma",
            congenitalHeartDefect: "Congenital heart defect",
            coronaryArteryDisease: "Coronary artery disease",
            hypertensiveHeartDisease: "Hypertensive heart disease",
            atrialFibrillation: "Atrial fibrillation",
            valvularHeartDisease: "Valvular heart disease",
            venousInsufficiency: "Venous insufficiency",
            hepaticSteatosis: "Hepatic steatosis",
            cirrhosis: "Cirrhosis",
            appendectomy: "Appendectomy",
            cholecystectomy: "Cholecystectomy",
            malformativeUropathy: "Malformative uropathy",
            malformativeUropathyRight: "Malformative uropathy right",
            malformativeUropathyLeft: "Malformative uropathy left",
            renalInsufficiency: "Renal insufficiency",
            renalLithiasis: "Kidney stones",
            benignProstaticHyperplasia: "BPH",
            pregnancy: "Pregnancy",
            menopause: "Menopause",
            cesareanSection: "Cesarean section",
            hysterectomy: "Hysterectomy",
            oophorectomy: "Oophorectomy",
            oophorectomyRight: "Oophorectomy right",
            oophorectomyLeft: "Oophorectomy left",
            scoliosis: "Scoliosis",
            hipOsteoarthritis: "Hip osteoarthritis",
            hipOsteoarthritisRight: "Hip osteoarthritis right",
            hipOsteoarthritisLeft: "Hip osteoarthritis left",
            kneeOsteoarthritis: "Knee osteoarthritis",
            kneeOsteoarthritisRight: "Knee osteoarthritis right",
            kneeOsteoarthritisLeft: "Knee osteoarthritis left",
            hipProsthesis: "Hip prosthesis",
            hipProsthesisRight: "Hip prosthesis right",
            hipProsthesisLeft: "Hip prosthesis left",
            kneeProsthesis: "Knee prosthesis",
            kneeProsthesisRight: "Knee prosthesis right",
            kneeProsthesisLeft: "Knee prosthesis left",
            atopicDermatitis: "Atopic dermatitis",
            acne: "Acne",
            psoriasis: "Psoriasis",
            hypothyroidism: "Hypothyroidism",
            hyperparathyroidism: "Hyperparathyroidism",
            hypertension: "Hypertension",
            diabetes: "Diabetes",
            dyslipidemia: "Dyslipidemia",
            hyperuricemia: "Hyperuricemia",
            bacterialPneumonia: "Bacterial pneumonia",
            toxoplasmosis: "Toxoplasmosis",
            allergy: "Allergy",
            brainCancer: "Brain cancer",
            lungCancer: "Lung cancer",
            colonCancer: "Colon cancer",
            pancreaticCancer: "Pancreatic cancer",
            prostateCancer: "Prostate cancer",
            breastCancer: "Breast cancer",
            breastCancerRight: "Breast cancer right",
            breastCancerLeft: "Breast cancer left",
            leukemia: "Leukemia",
            favorites: "Favorites",
            left: "left",
            right: "right",
            in: "in",
            yearsAgo: "ago",
            years: "years",
            atAge: "at age",
            inChildhood: "in childhood",
            since: "since",
            sinceAge: "since age",
            sinceChildhood: "since childhood",
            fatherSide: "paternal",
            motherSide: "maternal",
            rightAbbr: "R",
            leftAbbr: "L",
        },
        addEcosystem: {
            job: "Occupation:",
            workTime: "Working hours:",
            hoursPerWeek: "hours per week",
            workTimeLabel: "Working hours: h/week",
            noPartner: "No partner",
            inCouple: "In a relationship",
            parents: "Parents:",
            children: "Children:",
            pets: "Pets:",
            petsValue: "Animals:",
            violence: "Violence:",
            autonomousAtHome: "Independent at home",
            livesOnFloor: "Lives on",
            floor: "floor",
            livesOnFloorLabel: "Lives on ... floor",
            nursingHome: "In nursing home",
            walkingAid: "Walking aid:",
            homeHelp: "Home assistance:",
            sleepLatency: "Sleep latency:",
            nightWakings: "Night wakings:",
            averageSleepDuration: "Average sleep duration:",
            physicalActivity: "Physical activity:",
            drinks: "Beverages:",
            diet: "Diet:",
            noSmoking: "No smoking",
            smoking: "Smoking:",
            cigarettesPerDay: "cigarettes per day",
            smokingLabel: "Smoking: ... cig./day",
            noAlcohol: "No alcohol",
            alcohol: "Alcohol:",
            glassesPerWeek: "standard drinks per week",
            alcoholLabel: "Alcohol: ... drinks/week",
            noDrugs: "No drugs",
            cannabis: "Cannabis:",
            cocaine: "Cocaine:",
            opioids: "Opioids:",
            favorites: "Favorites",
            left: "left",
            right: "right",
            in: "in",
            yearsAgo: "ago",
            years: "years",
            atAge: "at age",
            since: "since",
            sinceAge: "since age",
        },
        no_entry: "No entry",
        header: {
            report: "Report",
            reportWithHistory: "Report with history",
            reportWithHistoryShort: "Full report",
            operativeReport: "Operative report",
            lab: "Laboratory",
            pharma: "Pharmacy",
            billing: "Invoice"
        },
        expression: {
            addSigns: "Add signs ...",
            isCorrected: "edited",
            history: "History",
            doctor: {
                importedFor: "Imported for:",
                by: "by: {secondaryHealthPro}",
                for: "for:",
            }
        },
        expressionMoreMenu: {
            createGroup: "Create group",
            rename: "Rename",
            correct: "Correct",
            moveToMonitored: "Move to Monitoring",
            moveToHistory: "Move to History",
            moveToEcosystem: "Move to Ecosystem",
            removeFromBar: "Remove from bar",
            nlp: "NLP",
        },
        conclusionGroup: {
            numberedTitle: "Group {number}",
            placeholder: "Plan, prescriptions ...",
        },
        suggestion: {
            sign: {
                Groups: "Groups",
                Measures: "General",
                CranialNerves1: "Cranial nerves",
                NeuroPeriph: "Peripheral neuro",
                MotorCoordination: "Balance, coordination",
                Head: "Head",
                Ent: "ENT",
                Thorax: "Thorax",
                Abdomen: "Abdomen",
                ShoulderL: "Shoulder L",
                ShoulderR: "Shoulder R",
                EllbowL: "Elbow L",
                EllbowR: "Elbow R",
                UpperArmL: "Upper arm L",
                UpperArmR: "Upper arm R",
                ForeArmL: "Forearm L",
                ForeArmR: "Forearm R",
                WristL: "Wrist L",
                WristR: "Wrist R",
                HandL: "Hand L",
                HandR: "Hand R",
                HipL: "Hip L",
                HipR: "Hip R",
                ThighL: "Thigh L",
                ThighR: "Thigh R",
                KneeL: "Knee L",
                KneeR: "Knee R",
                LowerLegL: "Lower leg L",
                LowerLegR: "Lower leg R",
                AnkleL: "Ankle L",
                AnkleR: "Ankle R",
                FootL: "Foot L",
                FootR: "Foot R",
                Lymph: "Lymphatic",
            },
            conclusion: {
                adminPerso: "Administrative / Personal",
            },
        },
        delegate: {
            title: 'Create an entry',
            label: 'On behalf of:',
            me: ' (me) '
        },
        search: {
            placeholder: "Name or matricule ...",
            noResult: "No results",
            new: "Create new patient",
            invalidDate: "invalid date",
            tooLong: "matricule too long",
            invalidChecksum: "invalid suffix",
            newPatient: "new patient",
        },
        create: {
            title: "Create patient for {name}",
            form: {
                cns: "Matricule",
                firstname: "First name",
                lastname: "Last name",
                mail: "Email",
                birthdate: "Date of birth",
                gender: "Gender",
                address: "Address",
                street: "Number and street",
                postalCode: "Postal code",
                locality: "City",
                country: "Country",
                favoritePhone: "Phone",
                mobile: "Mobile",
                import: "Paste from clipboard",
                importCreate: "Create patient from clipboard",
            },
            toast: {
                success: "Information was automatically retrieved.",
                error: "Error reading clipboard.",
                missingBirthdate: "Missing date of birth",
                emptyClipboard: "Clipboard empty",
                emptyClipboardDetail: "No valid text to paste."
            },
            message: {
                success: {
                    add: "Patient successfully added"
                },
                mandatory: "Enter either matricule or date of birth"
            }
        },
        rightBar: {
            subtitle: {
                monitoring: "Monitoring",
                treatment: "Treatment",
                history: "History",
                ecosystem: "Ecosystem"
            },
            vaccine: "Vaccines",
        },
        imageViewer: {
            syncZoom: "Sync zoom",
            syncPan: "Sync pan",
            close: "Close (Esc)",
            zoomIn: "Zoom in (+)",
            zoomOut: "Zoom out (-)",
            resetView: "Reset (0)",
            scroll: "Scroll",
            zoom: "Zoom",
            zoomInOut: "Zoom in/out",
            reset: "Reset",
            pan: "Pan",
            closeShort: "Close"
        },
        ophtalmo: {
            title: "Ophthalmology",
            correctiveLenses: "Corrective lenses",
            eyeGlasses: "Glasses",
            contactLenses: "Contact lenses",
            near: "Near",
            distant: "Distant",
            intermediate: "Intermediate",
            bifocal: "Bifocal",
            progressive: "Progressive",
            highAmetropy: "Ametropia > 6D",
            rigid: "RGP",
            rigidKeratoconus: "RGP - Keratoconus",
            rigidHighAmetropy: "RGP - Ametropia > 6D",
            leftEye: "Left Eye",
            rightEye: "Right Eye",
            os: "OS",
            od: "OD",
            ou: "OU",
            current: "Current",
            previous: "Previous",
            tonometer: "Tonometer",
            iop: "IOP",
            slitLamp: "Slit lamp",
            pachymetry: "Pachymetry",
            topography: "Topography",
            ultrasound: "Ultrasound",
            biometrics: "Biometrics",
            slitLampFindings: "Findings",
            refraction: "Refraction",
            objective: "Objective",
            subjective: "Subjective",
            final: "Final",
            sph: "SPH",
            cyl: "CYL",
            axs: "AXIS",
            va: "VA",
            add: "ADD",
            nva: "NVA",
            fundus: "Fundus",
            visualField: "Visual field",
            oct: "OCT",
            keratometry: "Keratometry",
            k1: "K1",
            k2: "K2",
            diopter: "D",
            noHistory: "No history",
            export: {
                success: "Data sent to refractor"
            }
        },
        resultDocument: {
            createStructuredData: "Create structured data",
            notInterpretable: "The group already contains data. Structured data creation disabled.",
            file: "File {mime}",
            cannotDisplay: "Cannot be displayed. Download available.",
        },
        document: {
            pid: "PID",
            paid: "Paid 100%",
            unpaid: "Unpaid",
            firstDay: "From",
            lastDay: "To",
            selectFinancialGroup: "Select group",
            warningInvoiceExists: "Invoice already exists",
            newBio: "New lab",
            finalizeTo: "Finalize to",
            imaging: {
                general: "Imaging",
                rxShort: "X-ray",
                rxFull: "X-ray",
                usShort: "US",
                usFull: "Ultrasound",
                ct: "CT",
                mrt: "MRI",
                petScan: "PET scan",
                other: "Other",
            },
            healthPro: {
                medicalSpecialty: "Referral request",
                nurse: "Nurse",
                physio: "Physiotherapist",
                ergo: "Occupational therapist",
                speech: "Speech therapist",
                podiatrist: "Podiatrist",
                pedicurist: "Pedicurist",
                dietitian: "Dietitian",
                psychotherapist: "Psychotherapist",
                psychologist: "Psychologist",
                psychomotor: "Psychomotor therapist",
                midwife: "Midwife"
            },
            luBill: {
                additionalInfo: "Additional information",
            },
            luBilledAct: {
                date: "Date",
                mainLocation: "Location",
                subLocation: "Facility",
                applyHospiClassToNextActs: "Apply class {actClass} from this day",
            },
            luBillAddon: {
                separateDates: "Separate dates",
                codeOrAct: "Code or act ...",
                acts: "Acts",
                generalActs: "General acts",
                technicalActs: "Technical acts",
                labActs: "Laboratory acts",
                withSupplement: "+ suppl.",
                personalActs: "Personal acts",
                hospitalisation: "Hospitalisation",
                prefix: "Prefix",
                removePrefix: "No prefix",
                suffix: "Suffix",
                executor: "Executor",
                surgeryAssistance: "Surgery assistance",
                customAct: {
                    description: "Description",
                    addCustomAct: "Add personal act",
                },
                favoriteAct: {
                    description: "Description",
                },
            },
            variableResolver: {
                patient: {
                    title: "Patient",
                    variable: {
                        patientfirstname:   "First name",
                        patientlastname:    "Last name",
                        patientfullname:    "Full name",
                        patientbirthdate:   "Date of birth",
                        patientage:         "Age",
                        patientphone:       "Phone",
                        patientstreet:      "Street",
                        patientcity:        "City",
                        patientfulladdress: "Full address",
                        patientemail:       "Email",
                    }
                },
                healthpro: {
                    title: "Healthcare professional",
                    variable: {
                        profirstname:       "First name",
                        prolastname:        "Last name",
                        profullname:        "Full name",
                    }
                },
                entry: {
                    title: "Consultation",
                    variable: {
                        currentdate:        "Date",
                        currenttime:        "Time",
                        currentlocation:    "Location"
                    }
                }
            },
            suggestions: {
                addVariable: "Add a variable",
                autoUseFirst: "Automatic fill",
                autoSelection: "Automatic selection",
                withConsultationDate: "with the consultation date",
                withThisSelection: "with this selection",
                withFirstSuggestion: "with the 1st suggestion",
                required: "required:",
                minimum: "minimum",
                examplesTitle: "Examples",
                examples: {
                    lines: {
                        title: "By line",
                        subtitle: "1 line = 1 suggestion",
                        example: "1x per month\n1x per week\n1x every 2 days"
                    },
                    blocks: {
                        title: "By block",
                        subtitle: "Multiple lines = 1 suggestion",
                        example: "I am referring this patient for consultation and report.\nPresenting with: \n ---\nI am referring this patient urgently for consultation and report.\nPresenting with:"
                    },
                    titledBlocks: {
                        title: "By block with title",
                        subtitle: "Multiple lines = 1 suggestion",
                        example: "--- Default\nI am referring this patient for consultation and report.\nPresenting with: \n\n --- Urgent\nI am referring this patient urgently for consultation and report.\nPresenting with:"
                    }
                }
            }
        },
        admin: {
            title: "Patient",
            relationship: {
                title: "Relations",
                privatePatient: "Private (patients)",
                privateCustom: "Private (other)",
                healthPro: "Healthcare professionals",
            },
            invoiceHistory: "Invoices",
            appointments: "Appointments",            
            note: "Notes {note}",
            noteTitle: "Notes:",
            phone: "Landline",
            mobile: "Mobile phone",
            birthday: "Date of birth",
            gender: "Gender",
            langs: "Language(s)",
            email: "Email",
            invalidEmail: "Invalid email",
            address: "Address",
            maps: "View",
            ssl: "Luxembourg Social Security",
            cnsNumber: {
                add: "Add matricule",
                title: "National Health Fund",
                copied: "Copied"
            },
            cnsUpdate: {
                message: "CNS successfully modified",
            },
            cmcm: {
                title: "CMCM",
            },
            cmcmModify: {
                title: "Complementary mutual health fund",
                useCmcm: "CMCM registered",
            },
            referringDoctor: {
                title: "Referring doctor",
                main: {
                    full: "Primary referring doctor",
                    short: "Primary RD",
                },
                second: {
                    full: "Substitute referring doctor",
                    short: "Substitute RD",
                },
                initialDeclarationDate: "Initial declaration",
                declarationNumber: "Declaration no.",
                createMrDeclaration: "Create declaration",
                createMrRpa: "Create RPA",
            },
            doc: {
                resume: "Summary",
                prevention: "Prevention sheet",
                bill: "Fee statement"
            },
            subtitle: {
                contactDetail: "Contact details",
                identityDetail: "Identity",
                notificationDetail: "Notification preferences"
            },
            subsubtitle: {
                contact: "Contacts",
                address: "Addresses",
                healthPro: "Healthcare professionals",
                cns: "CNS",
                cmcm: "CMCM",
                workAccident: "Work accidents",
                referringDoctor: "Referring doctor",
            },
            notification: {
                deliveryType: {
                    DELIVERY_EMAIL: 'Email',
                    DELIVERY_SMS: 'Sms',
                    DELIVERY_IN_APP: 'InApp'
                },
                preferredLanguage: 'Preferred language for communications',
                error: {
                    missingContactDetails: "One or more options are disabled because the information required to send notifications has not been specified."
                },
                noDefaultEmail: "Please select a default email address to change your email notification preferences."
            }
        },
        cns: {
            addCard: {
                title: "Matricule",
            },
            modifyCard: {
                title: "Matricule",
                useCnsNumber: "Use matricule",
            },
            editAffiliationNumberCard: {
                title: "Edit matricule",
                newCnsNumber: "New",
            },
        },
        entourageCard: {
            person: "Person",
            name: "Name",
            birthName: "Birth name",
            firstName: "First name",
            link: "Relationship",
            birthDate: "Date of birth",
            gender: "Administrative gender",
            biologicalSex: "Biological sex",
            languages: "Language(s)",
            note: "Note",
            phone: "Number",
            email: "Email",
            street: "Street",
            postalCode: "Code",
            locality: "City",
            country: "Country",
            updateSuccess: "Information successfully modified",
        },
        actionButton: {
            accessPatient: "File",
            newEntry: "New entry",
            accessCalendar: "Appt",
            createTask: "Task",
            scrollToTop: "Back to top",
        },
        filters: {
            bio: "Bio",
            imaging: "Imaging",
            reports: "Reports",
            other: "Other",
            requests: "Prescriptions",
            users: "User(s)",
            myConsultations: "My consultations",
        },
        pharmacy: {
            suggestions: {
                stop: "Stop",
                favorites: "Favorites",
                lastPrescription: "Last prescription",
                moreSubstances: "+ Substances",
                lessSubstances: "Fewer substances",
                sameFamily: "Same family",
                similarComposition: "Similar composition"
            },
            prescriptionInfo: {
                patientInfos: "Patient information",
                pharmacyInfos: "Pharmacy information",
                autoUseFirst: "Auto-fill",
            },
            posology: {
                then: "then",
                asNeeded: "If needed",
                during: "for",
                stopIn: "stop in",
                days: "day(s)",
                infos: "infos",
                sequence: "sequence",
                preference: {
                    addCurrentDose: "Add current dose",
                    emptyToUseSubstance: "Leave empty to use the posologies below",
                    addPosologies: "Add posologies",
                    posologies: "Posologies",
                    posologiesPlaceholder: "1 tablet morning and evening for 7 days"
                }
            },
            title: "Maximum prescription duration",
            customDurationDays: "days",
            DefaultDuration: "Prescription default",
            CustomDuration: "Custom",
            NotForPharmacy: "Never on prescription",
            label: {
                DefaultDuration: "Prescription: max duration",
                CustomDuration: "Prescription: {days} days",
                NotForPharmacy: "Off prescription"
            },
        },
        entry: {
            time: "Entry time",
            date: "Entry date",
            archive: {
                header: "Delete this entry",
                message: "You are about to delete an entry",
                confirm: "Entry successfully deleted"
            },
            archived: "Deleted",
            archivedBy: "Deleted by {author} on {deletedDate}",
            restore: {
                header: "Restore this entry",
                message: "You are about to restore a deleted entry",
                confirm: "Entry successfully restored"
            }
        },
        appointments: {
            empty: "No appointments",
            past: "Past appointments",
            coming: "Upcoming events",
            patientFullName: "Patient",
            healthProFullName: "Healthcare professionals",
            type: "Type of appointment",
            date: "Date of appointment",
            time: "Time of appointment",
            appointmentInfo: "Comments about the appointment",
            duration: "Duration of the appointment",
            appointmentDetails: "Appointment Details",
            minutes: "minutes",
            withoutAppointment: "Without an appointment"
        }
    },
    task: {
        taskTerm: 'Task',
        mainTitle: 'Tasks',
        myMissionsTitle: 'My tasks',
        assignedMissionsTitle: 'Delegated tasks',
        twoPersonTitle: 'Chat',
        emptyState: 'No tasks',
        taskBoxCustomMenu: {
            addTaskBox: "Add channel",
        },
        twoPersonMenu: {
            addTaskBox: "Add chat",
        },
        importFiles: {
            integrateRenamed: 'Integrate renamed files',
        },
        dropzone: {
            title: 'Add files',
            subtitle: 'Click or drag here',
        },
        noteGroup: {
            missions: "Tasks",
            notes: "Notes",
            future: "Upcoming",
            validated: "Completed"
        },
        taskPriority: {
            DuringShift: "1 - Quickly",
            EndOfShift: "2 - Today",
            NextDays: "3 - Next few days",
            None: "4 - Less urgent"
        },
        notePriority: {
            DuringShift: "1 - Very important",
            EndOfShift: "2 - Important",
            NextDays: "3 - Normal",
            None: "4 - Less important"
        },
        since: "from ...",
        private: "Private note",
        group: {
            message: {
                success: {
                    add: "Task group successfully created",
                    deactivate: "Group successfully deactivated",
                }
            }
        },
        import: {
            regibox: {
                message: {
                    startImport: {
                        summary: "Starting Regibox import",
                        detail: "File(s): {fileNumber}",
                    },
                    endImport: {
                        summary: "Regibox Import",
                        detail: "Complete imports: {successful}\nPartial imports: {tasksCreated}\nFailures: {failed}\n\n{errors}",
                    },
                    missingXmlData: "Files without .xml in this folder\nPlease remove them first",
                }
            }
        },
        status: {
            Pending: "Pending",
            Settled: "Validated",
            Rename: "To rename"
        },
        taskBoxDetail: {
            deactivate: "Deactivate this channel"
        },
        taskBox: {
            creator: "Creator",
        }
    },
    accounting: {
        noData: "No invoices found",
        remainingBalance: "Remaining balance",
        truncated: "Limited results",
        settled: "Paid",
        transaction: "Transaction",
        newTransaction: "New transaction",
        paymentType: "Payment type",        
        search: {
            hasMore: "Limited results, refine your search",
            minCharacters: "Minimum 4 characters...",
        },
        editTransaction: {
            locked: "This transaction can no longer be modified",
        },
        econnector: {
            service: {
                noPort: "eConnector: port error",
                error: "eConnector: error",
                technicalError: "Technical error with eConnector",
                unspecifiedError: "Unspecified error",
            },
            pid: {
                title: "PID",
                unavailable: "PID unavailable",
                simulationRefused: "Simulation refused",
                contest: "Contest",
                cnsPart: "CNS portion",
                patientPart: "Patient portion",
                contestedOn: "Contested on",
                redoSimulation: "Redo PID simulation",
                confirm: "Confirm"
            },
            ra: {
                title: "Accelerated reimbursement",
                paidForCns: "PAID for CNS",
                notPaidForCns: "NOT PAID for CNS",
                directTransmissionImpossible: "Direct CNS transmission impossible",
                confirm: "Confirm",
                withoutEConnector: "Without eConnector"
            },
            sendMh: {
                toast: {
                    error: "An error occurred while sending the fee statement to CNS",
                    errorWithDetails: "Error(s): {details}",
                    success: "Fee statement successfully transmitted to CNS"
                }
            },
            cancelMh: {
                toast: {
                    error: "An error occurred while cancelling the fee statement with CNS",
                    errorWithDetails: "Error(s): {details}",
                    success: "Fee statement successfully cancelled with CNS"
                },
                alreadyCancelled: "This invoice has already been cancelled",
                title: "Cancellation",
                titleEconnector: "eConnector cancellation",
                transmittedViaEconnector: "This invoice was transmitted via eConnector",
                cancellationImpossibleWithoutEconnector: "Cancellation impossible without eConnector",
                econnectorDisabled: "eConnector disabled",
                econnectorUnavailable: "eConnector unavailable",
                cancelAmount: "Cancel amount",
                cancellationReason: "Cancellation reason",
                required: "Required",
                invoiceNumber: "Invoice no.",
                invoiceDate: "From",
                total: "Total"
            },
            pidSimulation: {
                toast: {
                    expiredSummary: "PID simulation has expired",
                    expiredDetail: "Please start a new simulation",
                    error: "An error occurred during PID simulation",
                    errorWithDetails: "Error(s): {details}",
                    refused: "PID refused",
                    stillValid: "PID simulation still valid",
                }
            },
            pidValidation: {
                toast: {
                    error: "An error occurred during PID validation",
                    success: "PID successfully validated",
                    errorWithDetails: "Error(s): {details}",
                }
            },
            pidContestation: {
                selectAnomaly: "Please select the anomaly to contest",
                selectType: "Please select the type of contestation",
                type: {
                    interpretation: "Contestation of the interpretation of a pricing rule by the rules engine",
                    programatic: "Contestation of a programming error in the rules engine"
                },
                toast: {
                    error: "An error occurred during PID contestation",
                    success: "PID successfully contested",
                    errorWithDetails: "Error(s): {details}"
                }
            }
        },
        allMenu: {
            title: "All",
            precomplete: "To finalize"
        },
        financialSummary: {
            cancelled: "Cancelled",
            awaitingPayment: "Awaiting payment",
            revenues: "Revenues",
            directPayment: "Direct transfer",
            includeImmediatePayments: "Include PID and card in revenues",
        },
        financialGroupMenu: {
            disabled: "{groupName} (disabled)",
            fixChannels: {
                remainingBalance: "Remaining balance",
            },
            fixGroups: {
                tpCreatedOn: "Group of {date}",
                notSubmitted: "To do",
            },
            groupActions: {
                downloadBills: "Download invoices",
                downloadActs: "Download acts",
                downloadTransactions: "Download transactions",
                exportForBob50: "Export for BOB 50",
                openPidDashboard: "Transmission history",
            },
            channelTransactions: {
                cancelled: "cancel",
                bankAccount: "by transfer",
                cash: "in cash",
                bankCard: "by card",
                digitalPayment: "digital",
                luTp: "by TP",
                luTpSocial: "by social TP",
                luPid: "by PID",
                remainingBalance: "unpaid",
            },
            channelActions: {
                createPaymentReminders: "Create reminders",
                createLuTpSheet: "Create TP sheet",
                createLuTpSocialSheet: "Create social TP group",
            },
            searchInvoice: "Invoice",
            luTpSheet: "CNS statement",
        },
        filterMenu: {
            patient: "Patient",
            date: "Date",
            healthPro: "Doctor",
        },
        infos: {
            title: "Invoice(s)",
        },
        stats: {
            menu: {
                title: "History",
            },
            body: {
                title: "History of: {groupName}",
                nbMHSent: "Fees sent",
                nbPidValidated: "PIDs validated",
                nbPidContested: "PIDs contested",
                period: "From {start} to {end}"
            }
        },
        invoice: {
            notCns: "Non-CNS",
            reminder: "Reminder level {sequence}",
            invoices: "Invoice(s):",
        },
        invoiceReminder: {
            letter: "Letter",
            fee: "Fees",
            invoices: "Invoices: ",
            selectionAlone: "Invoices",
            selectionWithReminders: "Invoices with letter",
            remindersWithSettled: "Reminders with other invoices settled",
            remindersNotPrinted: "{count} reminder(s) not printed — settled since",
            reminders: "Reminders",
            reminder: "Reminder no. {sequence}",
            reminderSettings: {
                title: "Settings",
                saved: "Reminder settings",
            },
        },
    },
    login: {
        title: "Login",
        subtitle: "Please choose a login method to continue",
        smartCard: "Login with LuxTrust SmartCard",
        mobile: "Login with LuxTrust Mobile",
        noAccount: "Don't have an account?",
        askToBeContacted: "Request to be contacted",
        needHelp: "Need help?",
        contactUs: "Contact us",
        welcome: "Welcome to eSklepios",
        welcomeSubtitle: "Less paperwork, more care",
        catchphrase: "Technology at the service of health",
        description: "Benefit from powerful tools for better patient care",
    },
    refSheet: {
        title: "Sheet",
        list: "Sheets",
        names: "Names",
        searchRefSheet: "Search sheet",
        selectRefSheet: "Select a sheet",
        assessment: {
            signs: "Signs",
            prescriptionsFirst: "Prescriptions - 1st line",
            prescriptionsSecond: "Prescriptions - 2nd line",
        },
        tabs: {
            Sheet: "Sheet",
            Presentation: "Presentation",
            Etio: "Etio",
            Complic: "Complic",
            Treatment: "Treatment",
            Invoice: "Billing",
        },
        treatment: {
            medication: "Medications",
            healthPro: "Healthcare professionals",
            administratif: "Administrative",
        },
        invoice: {
            billingCodes: "Billing codes",
        },
        referenceDocument: {
            title: "Template",
            list: "Templates",
            create: "Create template",
            newTitle: "Template title",
            newTitleExample: "e.g. Initial rehabilitation or Standard report",
        },
        referenceLink: {
            title: "Reference link",
            list: "Reference links",
        },
        referenceFile: {
            title: "Reference file",
            list: "Reference files",
        },
        patientFile: {
            title: "Patient document",
            list: "Patient documents",
        },
    },
    posos: {
        error: {
            loading: "Error loading POSOS widget"
        },
        unresolved: {
            drugs: "Unanalyzed medications",
            strengthMismatches: "Approximations",
            conditions: "Unanalyzed medical history",
            allergies: "Unanalyzed allergies"
        }
    }    
} satisfies MessageSchema;